export const GET_LINE_INFO_DEMO_REQUEST = "GET_LINE_INFO_DEMO_REQUEST";
export const GET_LINE_INFO_DEMO_SUCCESS = "GET_LINE_INFO_DEMO_SUCCESS";
export const GET_LINE_INFO_DEMO_FAILED = "GET_LINE_INFO_DEMO_FAILED";

export const SET_LINE_ITEM_IPS_DEMO_REQUEST = "SET_LINE_ITEM_IPS_DEMO_REQUEST";
export const SET_LINE_ITEM_IPS_DEMO_SUCCESS = "SET_LINE_ITEM_IPS_DEMO_SUCCESS";
export const SET_LINE_ITEM_IPS_DEMO_FAILED = "SET_LINE_ITEM_IPS_DEMO_FAILED";

export const RESTART_LINE_ITEM_IPS_DEMO_REQUEST = "RESTART_LINE_ITEM_IPS_DEMO_REQUEST";
export const RESTART_LINE_ITEM_IPS_DEMO_SUCCESS = "RESTART_LINE_ITEM_IPS_DEMO_SUCCESS";
export const RESTART_LINE_ITEM_IPS_DEMO_FAILED = "RESTART_LINE_ITEM_IPS_DEMO_FAILED";

export const RESET_LINE_ITEM_DEMO_DATA = "RESET_LINE_ITEM_DEMO_DATA";

export const getLineItemInfoDemo = (type:any) => {
  return { type: GET_LINE_INFO_DEMO_REQUEST, payload: { type } };
};

  export const setLineIPsDemo = (rows: [{ipAddress:string,comment:string}],timer: any,handleSuccess:any,type:any) => {
  // const numberString = timerData.match(/\d+/)[0];
  // const timer = parseInt(numberString);
  //const ip = ips.split("\n");
  return { type: SET_LINE_ITEM_IPS_DEMO_REQUEST, payload: { rows,  timer,handleSuccess,type } };
};

export const restartLineIPsDemo = (handleSuccess:any,adsType:any) => {
  return { type: RESTART_LINE_ITEM_IPS_DEMO_REQUEST, payload: { handleSuccess },adsType };
};

export const resetLineItemDemoAction = () => {
  return { type: RESET_LINE_ITEM_DEMO_DATA };
};